import React from 'react';
import { Card, CardContent, CardActions, useTheme, useMediaQuery, Box, Typography } from '@mui/material';

const ResponsiveCard = ({
  children,
  title,
  subtitle,
  actions,
  sx = {},
  elevation = 1,
  ...props
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Card
      elevation={elevation}
      sx={{
        width: '100%',
        mb: isMobile ? 1 : 2,
        ...sx
      }}
      {...props}
    >
      {(title || subtitle) && (
        <CardContent sx={{ pb: isMobile ? 1 : 2 }}>
          {title && (
            <Typography
              variant={isMobile ? 'h6' : 'h5'}
              component="h2"
              gutterBottom={!!subtitle}
              sx={{ fontWeight: 600 }}
            >
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mb: title ? 0 : 1 }}
            >
              {subtitle}
            </Typography>
          )}
        </CardContent>
      )}

      {children && (
        <CardContent
          sx={{
            pt: title || subtitle ? 0 : undefined,
            pb: actions ? 1 : undefined,
            px: isMobile ? 2 : 3
          }}
        >
          {children}
        </CardContent>
      )}

      {actions && (
        <CardActions
          sx={{
            px: isMobile ? 2 : 3,
            pb: isMobile ? 1.5 : 2,
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? 1 : 0,
            '& > *': {
              width: isMobile ? '100%' : 'auto'
            }
          }}
        >
          {actions}
        </CardActions>
      )}
    </Card>
  );
};

export default ResponsiveCard;